/**
 * new Window PopUp
 * 새 창 열기
 *
 * @since: 2020-01-06
 * @author: kdydesign.kim
 */

// default options
const DEFAULT_PROPS = {
  width: 1420,
  height: 800,
  menubar: 'no',
  location: 'no',
  resizable: 'yes',
  scrollbars: 'yes',
  status: 'no'
}

// 새창 옵션 초기화
function initProps (props) {
  const opts = Object.assign({}, DEFAULT_PROPS, props)
  const joinOpts = _(opts).map((value, key) => `${key}=${value}`).join(',')

  return joinOpts
}

// TAMS
// sameOrigin: 동일 Domain 요청 여부 (GUI 실행)
export function newWindow ({store, url, instanceAssign, $q, props, sameOrigin = true} = {}) {
  try {
    if (sameOrigin) { // 동일 도메인 내 페이지
      const fullPath = url.split('?')[0].slice(1, url.length)
      const instanceKey = fullPath.split('/')[2]
      const options = initProps(props)

      const getCurrentLocale = store.getters['common/locale/getCurrentLocale']
      const
        newWindows = store.state.common.common.newWindows
      const
        authToken = store.state.common.authenticate.authToken ? store.state.common.authenticate.authToken : sessionStorage.getItem('SESSION_STORAGE_SET_TOKEN'),
        authIssueDate = store.state.common.authenticate.authIssueDate ? store.state.common.authenticate.authIssueDate : sessionStorage.getItem('SESSION_STORAGE_SET_ISSUE_DATE'),
        authRefreshToken = store.state.common.authenticate.authRefreshToken ? store.state.common.authenticate.authRefreshToken : sessionStorage.getItem('SESSION_STORAGE_SET_REFRESH_TOKEN')

      sessionStorage.setItem('SESSION_STORAGE_SET_LANG', getCurrentLocale)
      sessionStorage.setItem('SESSION_STORAGE_SET_TOKEN', authToken)
      sessionStorage.setItem('SESSION_STORAGE_SET_ISSUE_DATE', authIssueDate)
      sessionStorage.setItem('SESSION_STORAGE_SET_REFRESH_TOKEN', authRefreshToken)

      if (_.isFunction(instanceAssign)) {
        const filters = Object.assign({}, instanceAssign())

        localStorage.setItem('LOCAL_STORAGE_NEW_WINDOW', JSON.stringify(filters))
      }
      // GE Window 내 새창 띄우기 지원
      let urlhref = url
      if (store.getters['common/authenticate/isExistGeToken']) {
        const geToken = store.state.common.authenticate.geToken
        const separator = (url.indexOf('&') !== -1) ? '&' : '?'
        urlhref += `${separator}geWindow=${geToken}`
      }
      const windowInstance = window.open(urlhref, '', options)
      const windowKey = `${instanceKey}${Object.keys(newWindows).length}`

      newWindows[windowKey] = windowInstance

      // sessionStorage.clear()

      return windowInstance
    } else { // 외부 페이지
      const options = initProps(_.merge(props, {
        noopener: 'yes', // Chrome 해당 파라메터 추가 시, width, height 선언 무시됨. (기본 사이즈)
        noreferrer: 'yes'
      }))
      const windowInstance = window.open(url, '', options)
      return windowInstance
    }
  } catch (e) {
    window.$nuxt.$log('[New Windows Utils GUI Errors (newWindow)]', e)
  }
}

// TAMS
// New Tab Open (noopener 구현 - IE11, Chrome 66, FF 60, Safari 11.1)
export function newTab (url) {
  const link = document.createElement('a')
  link.target = '_blank'
  link.href = url
  link.rel = 'noopener noreferrer'
  document.body.appendChild(link)
  link.click()
  link.parentNode.removeChild(link)
}
